{
  "account.delete-confirm": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "account.delete-confirmation-instruction": [
    {
      "type": 0,
      "value": "Please type DELETE MY ACCOUNT to confirm:"
    }
  ],
  "account.delete-confirmation-title": [
    {
      "type": 0,
      "value": "Are you absolutely sure?"
    }
  ],
  "account.delete-confirmation-warning": [
    {
      "type": 0,
      "value": "This action cannot be undone. This will permanently delete your account and remove all data from our servers."
    }
  ],
  "account.delete-warning": [
    {
      "type": 0,
      "value": "作成したマインドマップは復元できません。すべての情報が削除され、復元することはできません。"
    }
  ],
  "account.delete-warning-collaborations": [
    {
      "type": 0,
      "value": "All shared mindmaps and collaborations"
    }
  ],
  "account.delete-warning-consequences": [
    {
      "type": 0,
      "value": "This will permanently delete:"
    }
  ],
  "account.delete-warning-data": [
    {
      "type": 0,
      "value": "All your personal data and account information"
    }
  ],
  "account.delete-warning-description": [
    {
      "type": 0,
      "value": "Once you delete your account, there is no going back. Please be certain."
    }
  ],
  "account.delete-warning-history": [
    {
      "type": 0,
      "value": "All account history and activity logs"
    }
  ],
  "account.delete-warning-mindmaps": [
    {
      "type": 0,
      "value": "All your mindmaps and their content"
    }
  ],
  "account.delete-warning-title": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "accountinfo.button": [
    {
      "type": 0,
      "value": "受け入れる"
    }
  ],
  "accountinfo.deleteaccount": [
    {
      "type": 0,
      "value": "アカウントを削除"
    }
  ],
  "accountinfo.email": [
    {
      "type": 0,
      "value": "メールアドレス"
    }
  ],
  "accountinfo.firstname": [
    {
      "type": 0,
      "value": "名"
    }
  ],
  "accountinfo.lastname": [
    {
      "type": 0,
      "value": "姓"
    }
  ],
  "accountinfo.personal-details": [
    {
      "type": 0,
      "value": "Personal Details"
    }
  ],
  "accountinfo.title": [
    {
      "type": 0,
      "value": "アカウント情報"
    }
  ],
  "action.cancel-button": [
    {
      "type": 0,
      "value": "キャンセル"
    }
  ],
  "action.close-button": [
    {
      "type": 0,
      "value": "閉じる"
    }
  ],
  "action.delete": [
    {
      "type": 0,
      "value": "削除"
    }
  ],
  "action.delete-description": [
    {
      "type": 0,
      "value": "削除されたマインドマップは復元できません。続行しますか？"
    }
  ],
  "action.delete-title": [
    {
      "type": 0,
      "value": "削除"
    }
  ],
  "action.duplicate": [
    {
      "type": 0,
      "value": "複製"
    }
  ],
  "action.export": [
    {
      "type": 0,
      "value": "エクスポート"
    }
  ],
  "action.history": [
    {
      "type": 0,
      "value": "履歴"
    }
  ],
  "action.history-description": [
    {
      "type": 0,
      "value": "過去90日間の変更履歴。"
    }
  ],
  "action.history-title": [
    {
      "type": 0,
      "value": "バージョン履歴"
    }
  ],
  "action.import": [
    {
      "type": 0,
      "value": "インポート"
    }
  ],
  "action.info": [
    {
      "type": 0,
      "value": "情報"
    }
  ],
  "action.label": [
    {
      "type": 0,
      "value": "ラベルを追加"
    }
  ],
  "action.new": [
    {
      "type": 0,
      "value": "新しいマップ"
    }
  ],
  "action.open": [
    {
      "type": 0,
      "value": "開く"
    }
  ],
  "action.print": [
    {
      "type": 0,
      "value": "印刷"
    }
  ],
  "action.publish": [
    {
      "type": 0,
      "value": "公開"
    }
  ],
  "action.rename": [
    {
      "type": 0,
      "value": "名前を変更"
    }
  ],
  "action.rename-description-placeholder": [
    {
      "type": 0,
      "value": "説明"
    }
  ],
  "action.rename-name-placeholder": [
    {
      "type": 0,
      "value": "名前"
    }
  ],
  "action.share": [
    {
      "type": 0,
      "value": "共有"
    }
  ],
  "activation.error.message": [
    {
      "type": 0,
      "value": "We couldn't activate your account. The activation link may be invalid or expired. Please contact support for assistance."
    }
  ],
  "activation.error.title": [
    {
      "type": 0,
      "value": "Activation Failed"
    }
  ],
  "activation.loading.desc": [
    {
      "type": 0,
      "value": "Please wait while we activate your account..."
    }
  ],
  "activation.loading.title": [
    {
      "type": 0,
      "value": "Activating Your Account"
    }
  ],
  "activation.success.message": [
    {
      "type": 0,
      "value": "Your account has been activated. You can now sign in and start creating mind maps."
    }
  ],
  "activation.success.title": [
    {
      "type": 0,
      "value": "Account Activated Successfully"
    }
  ],
  "admin.auth-type": [
    {
      "type": 0,
      "value": "認証タイプ"
    }
  ],
  "admin.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "admin.change-password-button": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.change-password-description": [
    {
      "type": 0,
      "value": "Change password for user: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "admin.change-password-title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "admin.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "admin.delete": [
    {
      "type": 0,
      "value": "削除"
    }
  ],
  "admin.delete-user": [
    {
      "type": 0,
      "value": "ユーザーを削除"
    }
  ],
  "admin.edit": [
    {
      "type": 0,
      "value": "編集"
    }
  ],
  "admin.edit-user": [
    {
      "type": 0,
      "value": "ユーザーを編集"
    }
  ],
  "admin.lock-status": [
    {
      "type": 0,
      "value": "ロック状態"
    }
  ],
  "admin.locked": [
    {
      "type": 0,
      "value": "ロック"
    }
  ],
  "admin.new-password": [
    {
      "type": 0,
      "value": "New Password"
    }
  ],
  "admin.password-error-facebook": [
    {
      "type": 0,
      "value": "This user is authenticated via Facebook. Password changes are not available for Facebook accounts. Please ask the user to manage their password through their Facebook account."
    }
  ],
  "admin.password-error-failed": [
    {
      "type": 0,
      "value": "Failed to change password"
    }
  ],
  "admin.password-error-google": [
    {
      "type": 0,
      "value": "This user is authenticated via Google. Password changes are not available for Google accounts. Please ask the user to manage their password through their Google account."
    }
  ],
  "admin.password-error-length": [
    {
      "type": 0,
      "value": "Password must be at least 6 characters"
    }
  ],
  "admin.password-error-mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match"
    }
  ],
  "admin.public": [
    {
      "type": 0,
      "value": "公開"
    }
  ],
  "admin.public-access": [
    {
      "type": 0,
      "value": "公開アクセス"
    }
  ],
  "admin.refresh": [
    {
      "type": 0,
      "value": "更新"
    }
  ],
  "admin.status": [
    {
      "type": 0,
      "value": "ステータス"
    }
  ],
  "admin.status-active": [
    {
      "type": 0,
      "value": "アクティブ"
    }
  ],
  "admin.status-clean": [
    {
      "type": 0,
      "value": "クリーン"
    }
  ],
  "admin.status-suspended": [
    {
      "type": 0,
      "value": "停止中"
    }
  ],
  "admin.suspend-user": [
    {
      "type": 0,
      "value": "ユーザーを停止"
    }
  ],
  "admin.suspension-reason": [
    {
      "type": 0,
      "value": "停止理由"
    }
  ],
  "admin.suspension-status": [
    {
      "type": 0,
      "value": "停止状態"
    }
  ],
  "admin.suspension.abuse": [
    {
      "type": 0,
      "value": "悪用"
    }
  ],
  "admin.suspension.inactivity": [
    {
      "type": 0,
      "value": "非アクティブ"
    }
  ],
  "admin.suspension.manual-review": [
    {
      "type": 0,
      "value": "手動レビュー"
    }
  ],
  "admin.suspension.other": [
    {
      "type": 0,
      "value": "その他"
    }
  ],
  "admin.suspension.security-concern": [
    {
      "type": 0,
      "value": "セキュリティ上の懸念"
    }
  ],
  "admin.suspension.terms-violation": [
    {
      "type": 0,
      "value": "利用規約違反"
    }
  ],
  "admin.system.db.url": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "admin.system.jvm": [
    {
      "type": 0,
      "value": "JVM"
    }
  ],
  "admin.system.memory": [
    {
      "type": 0,
      "value": "メモリ"
    }
  ],
  "admin.system.refresh": [
    {
      "type": 0,
      "value": "更新"
    }
  ],
  "admin.system.title": [
    {
      "type": 0,
      "value": "システム情報"
    }
  ],
  "admin.unsuspend-user": [
    {
      "type": 0,
      "value": "ユーザーの停止を解除"
    }
  ],
  "admin.view-xml": [
    {
      "type": 0,
      "value": "XMLを表示"
    }
  ],
  "changepwd.confirm-password": [
    {
      "type": 0,
      "value": "パスワードを確認"
    }
  ],
  "changepwd.description": [
    {
      "type": 0,
      "value": "アカウントの新しいパスワードを入力してください。"
    }
  ],
  "changepwd.password": [
    {
      "type": 0,
      "value": "パスワード"
    }
  ],
  "changepwd.password-match": [
    {
      "type": 0,
      "value": "パスワードが一致しません。もう一度お試しください。"
    }
  ],
  "changepwd.title": [
    {
      "type": 0,
      "value": "パスワードを変更"
    }
  ],
  "common.allow-email-notifications": [
    {
      "type": 0,
      "value": "メール通知を許可"
    }
  ],
  "common.delete": [
    {
      "type": 0,
      "value": "削除"
    }
  ],
  "common.delete-tag": [
    {
      "type": 0,
      "value": "タグを削除"
    }
  ],
  "common.email": [
    {
      "type": 0,
      "value": "メール"
    }
  ],
  "common.emails": [
    {
      "type": 0,
      "value": "メール"
    }
  ],
  "common.first-name": [
    {
      "type": 0,
      "value": "名"
    }
  ],
  "common.last-name": [
    {
      "type": 0,
      "value": "姓"
    }
  ],
  "common.loading": [
    {
      "type": 0,
      "value": "読み込み中..."
    }
  ],
  "common.locale": [
    {
      "type": 0,
      "value": "言語"
    }
  ],
  "common.login-form": [
    {
      "type": 0,
      "value": "ログインフォーム"
    }
  ],
  "common.maps-list": [
    {
      "type": 0,
      "value": "マップ一覧"
    }
  ],
  "common.open-drawer": [
    {
      "type": 0,
      "value": "メニューを開く"
    }
  ],
  "common.others": [
    {
      "type": 0,
      "value": "その他"
    }
  ],
  "common.refresh": [
    {
      "type": 0,
      "value": "更新"
    }
  ],
  "common.registration-form": [
    {
      "type": 0,
      "value": "登録フォーム"
    }
  ],
  "common.retry": [
    {
      "type": 0,
      "value": "再試行"
    }
  ],
  "common.settings": [
    {
      "type": 0,
      "value": "設定"
    }
  ],
  "common.terms-notice": [
    {
      "type": 0,
      "value": "By continuing, you agree to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Terms of Service"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Privacy Policy"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "common.wait": [
    {
      "type": 0,
      "value": "お待ちください..."
    }
  ],
  "create.button": [
    {
      "type": 0,
      "value": "作成"
    }
  ],
  "create.description": [
    {
      "type": 0,
      "value": "新しいマップの名前と説明を入力してください。"
    }
  ],
  "create.title": [
    {
      "type": 0,
      "value": "新しいマインドマップを作成"
    }
  ],
  "deletem.title": [
    {
      "type": 0,
      "value": "選択されたすべてのマップが削除されます"
    }
  ],
  "dialog.loading": [
    {
      "type": 0,
      "value": "読み込み中..."
    }
  ],
  "duplicate.copy-prefix": [
    {
      "type": 0,
      "value": "のコピー"
    }
  ],
  "duplicate.title": [
    {
      "type": 0,
      "value": "複製"
    }
  ],
  "error.contact-support": [
    {
      "type": 0,
      "value": "お困りですか？こちらまでご連絡ください："
    },
    {
      "type": 1,
      "value": "support"
    }
  ],
  "error.generic-message": [
    {
      "type": 0,
      "value": "後でもう一度お試しいただくか、問題が解決しない場合はサポートまでご連絡ください。"
    }
  ],
  "error.generic-title": [
    {
      "type": 0,
      "value": "問題が発生しました。"
    }
  ],
  "error.go-back": [
    {
      "type": 0,
      "value": "Go Back"
    }
  ],
  "error.go-home": [
    {
      "type": 0,
      "value": "Go to Home"
    }
  ],
  "error.go-to-login": [
    {
      "type": 0,
      "value": "Sign In"
    }
  ],
  "error.map-title-required": [
    {
      "type": 0,
      "value": "マップのタイトルは必須で、空にすることはできません"
    }
  ],
  "error.map-unavailable-message": [
    {
      "type": 0,
      "value": "このマインドマップは、サイトポリシーに違反しているため、公開表示には利用できません。さらにサポートが必要な場合は、support@wisemapping.com にお問い合わせください。"
    }
  ],
  "error.map-unavailable-title": [
    {
      "type": 0,
      "value": "このマインドマップは公開表示には利用できません。"
    }
  ],
  "error.not-found-message": [
    {
      "type": 0,
      "value": "お探しのページは削除されたか、名前が変更されたか、一時的に利用できない可能性があります。"
    }
  ],
  "error.not-found-title": [
    {
      "type": 0,
      "value": "そのページが見つかりません。"
    }
  ],
  "error.page-title": [
    {
      "type": 0,
      "value": "予期しないエラー | WiseMapping"
    }
  ],
  "error.permission-denied-message": [
    {
      "type": 0,
      "value": "アクセスできるはずだと思われる場合は、管理者にお問い合わせください。"
    }
  ],
  "error.permission-denied-title": [
    {
      "type": 0,
      "value": "このページにアクセスする権限がありません。"
    }
  ],
  "expired.description": [
    {
      "type": 0,
      "value": "現在のセッションが期限切れです。ログインして再試行してください。"
    }
  ],
  "expired.title": [
    {
      "type": 0,
      "value": "セッションが期限切れです"
    }
  ],
  "export.desc": [
    {
      "type": 0,
      "value": "このマップを希望の形式でエクスポートし、プレゼンテーションで使用したり、メールで共有したりできます"
    }
  ],
  "export.document": [
    {
      "type": 0,
      "value": "マインドマップツール：マインドマップをサードパーティのマインドマップツール形式でエクスポート"
    }
  ],
  "export.document-label": [
    {
      "type": 0,
      "value": "ドキュメント：マインドマップを共有準備完了の独立したドキュメントとしてエクスポート"
    }
  ],
  "export.image": [
    {
      "type": 0,
      "value": "画像：すべての色と形状を含むマップのグラフィック表現を取得"
    }
  ],
  "export.img-center": [
    {
      "type": 0,
      "value": "中央揃えしてフィット"
    }
  ],
  "export.title": [
    {
      "type": 0,
      "value": "エクスポート"
    }
  ],
  "export.warning": [
    {
      "type": 0,
      "value": "画像（SVG、PNG、JPEG、PDF）へのエクスポートは、エディターツールバーでのみ利用可能です。"
    }
  ],
  "footer.aboutus": [
    {
      "type": 0,
      "value": "私たちについて"
    }
  ],
  "footer.col-community": [
    {
      "type": 0,
      "value": "コミュニティ"
    }
  ],
  "footer.col-company": [
    {
      "type": 0,
      "value": "会社"
    }
  ],
  "footer.col-support": [
    {
      "type": 0,
      "value": "サポート"
    }
  ],
  "footer.contactus": [
    {
      "type": 0,
      "value": "お問い合わせ"
    }
  ],
  "footer.copyright": [
    {
      "type": 0,
      "value": "© "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " WiseMapping LLC"
    }
  ],
  "footer.donations": [
    {
      "type": 0,
      "value": "寄付"
    }
  ],
  "footer.faq": [
    {
      "type": 0,
      "value": "よくある質問"
    }
  ],
  "footer.feedback": [
    {
      "type": 0,
      "value": "フィードバック"
    }
  ],
  "footer.news": [
    {
      "type": 0,
      "value": "ニュース"
    }
  ],
  "footer.opensource": [
    {
      "type": 0,
      "value": "オープンソース"
    }
  ],
  "footer.privacypolicy": [
    {
      "type": 0,
      "value": "プライバシーポリシー"
    }
  ],
  "footer.termsandconditions": [
    {
      "type": 0,
      "value": "利用規約"
    }
  ],
  "footer.twitter": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "forgot.desc": [
    {
      "type": 0,
      "value": "パスワードをリセットするためのメールをお送りします。"
    }
  ],
  "forgot.email": [
    {
      "type": 0,
      "value": "メールアドレス"
    }
  ],
  "forgot.oauth.back": [
    {
      "type": 0,
      "value": "ログインに戻る"
    }
  ],
  "forgot.oauth.message": [
    {
      "type": 0,
      "value": "パスワードは不要です。FacebookまたはGoogleでログインしてください。"
    }
  ],
  "forgot.page-title": [
    {
      "type": 0,
      "value": "パスワードを忘れた場合 | WiseMapping"
    }
  ],
  "forgot.register": [
    {
      "type": 0,
      "value": "復旧リンクを送信"
    }
  ],
  "forgot.success.desc": [
    {
      "type": 0,
      "value": "パスワードをリセットできるメールをお送りしました。数分以内に受信されるはずです。"
    }
  ],
  "forgot.success.title": [
    {
      "type": 0,
      "value": "一時パスワードが送信されました。"
    }
  ],
  "forgot.title": [
    {
      "type": 0,
      "value": "パスワードをリセット"
    }
  ],
  "forgotsuccess.page-title": [
    {
      "type": 0,
      "value": "パスワード復旧 | WiseMapping"
    }
  ],
  "header.donthaveaccount": [
    {
      "type": 0,
      "value": "アカウントをお持ちでないですか？"
    }
  ],
  "header.haveaccount": [
    {
      "type": 0,
      "value": "すでにアカウントをお持ちですか？"
    }
  ],
  "help.support": [
    {
      "type": 0,
      "value": "サポート"
    }
  ],
  "history.no-changes": [
    {
      "type": 0,
      "value": "利用可能な変更はありません"
    }
  ],
  "import.button": [
    {
      "type": 0,
      "value": "作成"
    }
  ],
  "import.description": [
    {
      "type": 0,
      "value": "WiseMappingとFreemindのマップをマップリストにインポートできます。インポートするファイルを選択してください。"
    }
  ],
  "import.error-file": [
    {
      "type": 0,
      "value": "インポートエラー "
    },
    {
      "type": 1,
      "value": "error"
    }
  ],
  "import.title": [
    {
      "type": 0,
      "value": "既存のマインドマップをインポート"
    }
  ],
  "info.basic-info": [
    {
      "type": 0,
      "value": "基本情報"
    }
  ],
  "info.button": [
    {
      "type": 0,
      "value": "受け入れる"
    }
  ],
  "info.creation-time": [
    {
      "type": 0,
      "value": "作成日"
    }
  ],
  "info.creator": [
    {
      "type": 0,
      "value": "作成者"
    }
  ],
  "info.description": [
    {
      "type": 0,
      "value": "説明"
    }
  ],
  "info.description-msg": [
    {
      "type": 0,
      "value": "マップを公開することで、インターネット上のすべての人に表示されます。"
    }
  ],
  "info.modified-time": [
    {
      "type": 0,
      "value": "最終更新日"
    }
  ],
  "info.modified-tny": [
    {
      "type": 0,
      "value": "最終更新者"
    }
  ],
  "info.name": [
    {
      "type": 0,
      "value": "名前"
    }
  ],
  "info.public-visibility": [
    {
      "type": 0,
      "value": "公開表示"
    }
  ],
  "info.sharing": [
    {
      "type": 0,
      "value": "共有"
    }
  ],
  "info.starred": [
    {
      "type": 0,
      "value": "お気に入り"
    }
  ],
  "info.title": [
    {
      "type": 0,
      "value": "情報"
    }
  ],
  "label.add-button": [
    {
      "type": 0,
      "value": "ラベルを追加"
    }
  ],
  "label.add-for": [
    {
      "type": 0,
      "value": "マップのラベルを編集："
    }
  ],
  "label.add-placeholder": [
    {
      "type": 0,
      "value": "ラベルタイトル"
    }
  ],
  "label.change-color": [
    {
      "type": 0,
      "value": "ラベルの色を変更"
    }
  ],
  "label.delete-description": [
    {
      "type": 0,
      "value": "が削除され、既存のすべてのマップとの関連付けも含まれます。続行しますか？"
    }
  ],
  "label.delete-title": [
    {
      "type": 0,
      "value": "ラベル削除を確認"
    }
  ],
  "label.description": [
    {
      "type": 0,
      "value": "ラベルを使用してマップを整理します。"
    }
  ],
  "label.maps-count": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " マップ"
    }
  ],
  "label.title": [
    {
      "type": 0,
      "value": "ラベルを追加"
    }
  ],
  "language.change": [
    {
      "type": 0,
      "value": "言語を変更"
    }
  ],
  "language.help": [
    {
      "type": 0,
      "value": "翻訳を支援"
    }
  ],
  "login.desc": [
    {
      "type": 0,
      "value": "アカウントにログイン"
    }
  ],
  "login.division": [
    {
      "type": 0,
      "value": "または"
    }
  ],
  "login.email": [
    {
      "type": 0,
      "value": "メールアドレス"
    }
  ],
  "login.error": [
    {
      "type": 0,
      "value": "入力されたメールアドレスまたはパスワードが無効です。"
    }
  ],
  "login.facebook.button": [
    {
      "type": 0,
      "value": "Facebookでサインイン"
    }
  ],
  "login.forgotpwd": [
    {
      "type": 0,
      "value": "パスワードを忘れましたか？"
    }
  ],
  "login.generic-error": [
    {
      "type": 0,
      "value": "An error occurred during authentication. Please try again."
    }
  ],
  "login.google.button": [
    {
      "type": 0,
      "value": "Googleでサインイン"
    }
  ],
  "login.oauth-error": [
    {
      "type": 0,
      "value": "OAuth authentication failed. Please try again or use a different sign-in method."
    }
  ],
  "login.page-title": [
    {
      "type": 0,
      "value": "ログイン | WiseMapping"
    }
  ],
  "login.password": [
    {
      "type": 0,
      "value": "パスワード"
    }
  ],
  "login.redirecting": [
    {
      "type": 0,
      "value": "リダイレクト中..."
    }
  ],
  "login.server-error": [
    {
      "type": 0,
      "value": "An unexpected error occurred. Please try again later."
    }
  ],
  "login.shared-map-notice": [
    {
      "type": 0,
      "value": "マインドマップが共有されました。アクセスするにはログインしてください。アカウントをお持ちでない方は、無料で登録するか、Google/Facebookアカウントをご利用ください。"
    }
  ],
  "login.signin": [
    {
      "type": 0,
      "value": "サインイン"
    }
  ],
  "login.signup": [
    {
      "type": 0,
      "value": "サインアップ"
    }
  ],
  "login.title": [
    {
      "type": 0,
      "value": "ようこそ"
    }
  ],
  "map.creator": [
    {
      "type": 0,
      "value": "作成者"
    }
  ],
  "map.delete-selected": [
    {
      "type": 0,
      "value": "選択したものを削除"
    }
  ],
  "map.last-update": [
    {
      "type": 0,
      "value": "最終更新"
    }
  ],
  "map.more-actions": [
    {
      "type": 0,
      "value": "その他のアクション"
    }
  ],
  "map.name": [
    {
      "type": 0,
      "value": "名前"
    }
  ],
  "map.tooltip-add": [
    {
      "type": 0,
      "value": "選択したものにラベルを追加"
    }
  ],
  "maps.auth-required-default-message": [
    {
      "type": 0,
      "value": "You need to sign in to view your maps."
    }
  ],
  "maps.auth-required-heading": [
    {
      "type": 0,
      "value": "Sign in to access your maps"
    }
  ],
  "maps.auth-required-login": [
    {
      "type": 0,
      "value": "Go to login"
    }
  ],
  "maps.auth-required-title": [
    {
      "type": 0,
      "value": "Sign In Required | WiseMapping"
    }
  ],
  "maps.choose-file": [
    {
      "type": 0,
      "value": "ファイルを選択"
    }
  ],
  "maps.copilot-button": [
    {
      "type": 0,
      "value": "AIコパイロット"
    }
  ],
  "maps.copilot-dialog.continue": [
    {
      "type": 0,
      "value": "コパイロットを開く"
    }
  ],
  "maps.copilot-dialog.description": [
    {
      "type": 0,
      "value": "Mind Map Copilot は、あなたのプロンプトを構造化されたマインドマップに変換する ChatGPT 搭載のブレーンストーミング支援ツールです。新しいタブで開きますので、アイデアを膨らませ、トピックを生成し、ベストな内容を WiseMapping に持ち帰ってください。"
    }
  ],
  "maps.copilot-dialog.title": [
    {
      "type": 0,
      "value": "ChatGPT 搭載マインドマップコパイロット"
    }
  ],
  "maps.copilot-tooltip": [
    {
      "type": 0,
      "value": "AIコパイロットでマインドマップを始める"
    }
  ],
  "maps.create-tooltip": [
    {
      "type": 0,
      "value": "新しいマインドマップを作成"
    }
  ],
  "maps.empty-result": [
    {
      "type": 0,
      "value": "現在のフィルター条件に一致するマインドマップが見つかりません。"
    }
  ],
  "maps.import-desc": [
    {
      "type": 0,
      "value": "他のツールからインポート"
    }
  ],
  "maps.modified": [
    {
      "type": 0,
      "value": "変更"
    }
  ],
  "maps.modified-by": [
    {
      "type": 0,
      "value": "変更者"
    }
  ],
  "maps.modified-by-desc": [
    {
      "type": 1,
      "value": "on"
    },
    {
      "type": 0,
      "value": "に"
    },
    {
      "type": 1,
      "value": "by"
    },
    {
      "type": 0,
      "value": "が変更"
    }
  ],
  "maps.nav-all": [
    {
      "type": 0,
      "value": "すべて"
    }
  ],
  "maps.nav-onwned": [
    {
      "type": 0,
      "value": "所有"
    }
  ],
  "maps.nav-public": [
    {
      "type": 0,
      "value": "公開"
    }
  ],
  "maps.nav-shared": [
    {
      "type": 0,
      "value": "共有"
    }
  ],
  "maps.nav-starred": [
    {
      "type": 0,
      "value": "お気に入り"
    }
  ],
  "maps.page-title": [
    {
      "type": 0,
      "value": "マイマップ | WiseMapping"
    }
  ],
  "maps.revert": [
    {
      "type": 0,
      "value": "元に戻す"
    }
  ],
  "maps.search-action": [
    {
      "type": 0,
      "value": "検索..."
    }
  ],
  "maps.tooltip-open": [
    {
      "type": 0,
      "value": "編集用に開く"
    }
  ],
  "maps.tooltip-starred": [
    {
      "type": 0,
      "value": "お気に入り"
    }
  ],
  "maps.view": [
    {
      "type": 0,
      "value": "表示"
    }
  ],
  "menu.account": [
    {
      "type": 0,
      "value": "アカウント"
    }
  ],
  "menu.admin-console": [
    {
      "type": 0,
      "value": "Admin Console"
    }
  ],
  "menu.change-password": [
    {
      "type": 0,
      "value": "パスワードを変更"
    }
  ],
  "menu.signout": [
    {
      "type": 0,
      "value": "サインアウト"
    }
  ],
  "publish.checkbox": [
    {
      "type": 0,
      "value": "公開共有を有効にする"
    }
  ],
  "publish.copied": [
    {
      "type": 0,
      "value": "Copied to clipboard!"
    }
  ],
  "publish.description": [
    {
      "type": 0,
      "value": "マップを公開することで、インターネット上のすべての人に表示されます。"
    }
  ],
  "publish.embedded": [
    {
      "type": 0,
      "value": "埋め込み"
    }
  ],
  "publish.embedded-msg": [
    {
      "type": 0,
      "value": "このコードスニペットをコピーして、ブログやページに埋め込みます："
    }
  ],
  "publish.public-url": [
    {
      "type": 0,
      "value": "公開URL"
    }
  ],
  "publish.public-url-msg": [
    {
      "type": 0,
      "value": "以下のリンクをコピーして貼り付け、同僚とマップを共有します："
    }
  ],
  "publish.title": [
    {
      "type": 0,
      "value": "公開"
    }
  ],
  "registation.success-title": [
    {
      "type": 0,
      "value": "登録成功 | WiseMapping"
    }
  ],
  "registration.callback.back": [
    {
      "type": 0,
      "value": "ログインに戻る"
    }
  ],
  "registration.callback.confirm.description": [
    {
      "type": 0,
      "value": "同じメールアドレスのアカウントが以前に登録されています。"
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": "アカウントをそのWiseMappingアカウントにリンクしますか？"
    }
  ],
  "registration.callback.confirm.title": [
    {
      "type": 0,
      "value": "確認"
    }
  ],
  "registration.callback.sync": [
    {
      "type": 0,
      "value": "アカウントを同期"
    }
  ],
  "registration.callback.waiting.description": [
    {
      "type": 0,
      "value": "身元を確認中です。お待ちください"
    }
  ],
  "registration.callback.waiting.title": [
    {
      "type": 0,
      "value": "完了中..."
    }
  ],
  "registration.desc": [
    {
      "type": 0,
      "value": "登録は無料で、すぐに完了します"
    }
  ],
  "registration.division": [
    {
      "type": 0,
      "value": "または"
    }
  ],
  "registration.email": [
    {
      "type": 0,
      "value": "メールアドレス"
    }
  ],
  "registration.error.title": [
    {
      "type": 0,
      "value": "登録失敗"
    }
  ],
  "registration.facebook.button": [
    {
      "type": 0,
      "value": "Facebookで登録"
    }
  ],
  "registration.firstname": [
    {
      "type": 0,
      "value": "名"
    }
  ],
  "registration.form-legend": [
    {
      "type": 0,
      "value": "Account Information"
    }
  ],
  "registration.google.button": [
    {
      "type": 0,
      "value": "Googleでサインアップ"
    }
  ],
  "registration.lastname": [
    {
      "type": 0,
      "value": "姓"
    }
  ],
  "registration.page-title": [
    {
      "type": 0,
      "value": "登録 | WiseMapping"
    }
  ],
  "registration.password": [
    {
      "type": 0,
      "value": "パスワード"
    }
  ],
  "registration.recaptcha-notice": [
    {
      "type": 0,
      "value": "このサイトはreCAPTCHAで保護されており、Googleの"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "プライバシーポリシー"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": "と"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "利用規約"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": "が適用されます。"
    }
  ],
  "registration.register": [
    {
      "type": 0,
      "value": "登録"
    }
  ],
  "registration.success.already-activated": [
    {
      "type": 0,
      "value": "Already activated your account?"
    }
  ],
  "registration.success.check-spam": [
    {
      "type": 0,
      "value": "If you don't see the email, please check your spam folder."
    }
  ],
  "registration.success.email-sent": [
    {
      "type": 0,
      "value": "We've sent an activation email to your inbox. Please check your email and click on the activation link to activate your account."
    }
  ],
  "registration.success.title": [
    {
      "type": 0,
      "value": "Registration Successful!"
    }
  ],
  "registration.title": [
    {
      "type": 0,
      "value": "メンバーになる"
    }
  ],
  "rename.description": [
    {
      "type": 0,
      "value": "新しいマップの名前と説明を入力してください。"
    }
  ],
  "rename.title": [
    {
      "type": 0,
      "value": "名前を変更"
    }
  ],
  "reset-password.confirm-password": [
    {
      "type": 0,
      "value": "Confirm new password"
    }
  ],
  "reset-password.desc": [
    {
      "type": 0,
      "value": "Enter your new password below."
    }
  ],
  "reset-password.invalid-link": [
    {
      "type": 0,
      "value": "Invalid password reset link. Please request a new one."
    }
  ],
  "reset-password.mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match."
    }
  ],
  "reset-password.page-title": [
    {
      "type": 0,
      "value": "Reset Password | WiseMapping"
    }
  ],
  "reset-password.password": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "reset-password.request-new": [
    {
      "type": 0,
      "value": "Request new link"
    }
  ],
  "reset-password.submit": [
    {
      "type": 0,
      "value": "Set new password"
    }
  ],
  "reset-password.title": [
    {
      "type": 0,
      "value": "Set a new password"
    }
  ],
  "reset-password.too-long": [
    {
      "type": 0,
      "value": "Password must be less than 40 characters."
    }
  ],
  "reset-password.too-short": [
    {
      "type": 0,
      "value": "Password must be at least 8 characters."
    }
  ],
  "role.editor": [
    {
      "type": 0,
      "value": "編集者"
    }
  ],
  "role.owner": [
    {
      "type": 0,
      "value": "所有者"
    }
  ],
  "role.viewer": [
    {
      "type": 0,
      "value": "閲覧者"
    }
  ],
  "share.add-button": [
    {
      "type": 0,
      "value": "共有"
    }
  ],
  "share.add-message": [
    {
      "type": 0,
      "value": "メッセージを追加"
    }
  ],
  "share.adding-button": [
    {
      "type": 0,
      "value": "Sharing..."
    }
  ],
  "share.can-edit": [
    {
      "type": 0,
      "value": "編集可能"
    }
  ],
  "share.delete": [
    {
      "type": 0,
      "value": "共同編集者を削除"
    }
  ],
  "share.delete-description": [
    {
      "type": 0,
      "value": "共同編集者を追加。即座にメールでアクセスが送信され、一緒に編集できます。"
    }
  ],
  "share.delete-title": [
    {
      "type": 0,
      "value": "人と共有"
    }
  ],
  "share.message": [
    {
      "type": 0,
      "value": "メッセージ"
    }
  ],
  "share.table.actions": [
    {
      "type": 0,
      "value": "Actions"
    }
  ],
  "share.table.collaborator": [
    {
      "type": 0,
      "value": "Collaborator"
    }
  ],
  "share.table.role": [
    {
      "type": 0,
      "value": "Role"
    }
  ],
  "theme.dark": [
    {
      "type": 0,
      "value": "ダーク"
    }
  ],
  "theme.light": [
    {
      "type": 0,
      "value": "ライト"
    }
  ],
  "theme.toggle": [
    {
      "type": 0,
      "value": "テーマ切り替え"
    }
  ],
  "validation.title-required": [
    {
      "type": 0,
      "value": "タイトルは必須です"
    }
  ]
}
